import { Component, HostListener, OnInit } from '@angular/core';
import { Navigator } from '../../components/menu/navigator';
import { Platform, PopoverController } from '@ionic/angular';
import { ConfigService } from 'src/app/services/config/config.service';
import { NotificationHandlerService } from 'src/app/services/notification-handler/notification-handler.service';

@Component({
  selector: 'app-bonus-content',
  templateUrl: './bonus-content.page.html',
  styleUrls: ['./bonus-content.page.scss'],
})
export class BonusContentPage implements OnInit {

  public content: BonusContent;
  basePath = this.config.getConfig().CDN_BASEURL + "/assets/imgs/";
  private isIOSApp:boolean = false;
  private timeoutAutoHide: any;
  private isDesktopWeb:boolean = false;
  private isIpad:boolean = false;
  private activePopover;
  private title: string = "YOUR COINS HAVE BEEN DELIVERED";
  
  constructor(
    private readonly navigator: Navigator,
    public popoverController: PopoverController,
    public config: ConfigService,
    private platform:Platform,
    private notificationHandler: NotificationHandlerService
  ) {
    this.activePopover = this.navigator?.activePopovers[this.navigator.activePopovers.length - 1];
    this.content = this.activePopover?.componentProps?.data;
    if(this.content.title) {
      this.title = this.content.title;
    }
    this.isIOSApp = this.platform.is("capacitor") && this.platform.is("ios");
    this.isDesktopWeb = this.platform.is('desktop')
    this.isIpad =  this.platform.is('ipad');
  }

  ngOnInit() {
    if (this.content.istopLeft) this.setPopoverPosition(); // setting up the position for model controller
    this.callAutoHide(); // checkiing is auto hide content done
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
   this.changePropertyInMobile();
  }

  callAutoHide() {
    if (this.content.isAutoHideEnabled && this.content.isAutoHideTimeout) {
      this.timeoutAutoHide = setTimeout(() => {
        this.activePopover.dismiss();
        this.navigator.dismissPopover();
        this.notificationHandler.isNotificationHalted = false;
      }, this.content.isAutoHideTimeout);
    }
  }

  closePopover() {
    clearTimeout(this.timeoutAutoHide);
    
    this.activePopover.dismiss();
    this.navigator.dismissPopover();
    this.notificationHandler.isNotificationHalted = false;
  }

  setPopoverPosition() {
    setTimeout(() => {
      const isIpadLandscape = this.isIpad && this.platform.isLandscape();
      const popover: any = document.querySelector('.auto-dismiss-popover');
      const popover_view: any = document.querySelector('.popover-viewport');
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      const addMoreLeftSpace = (this.isIOSApp && (screenWidth >= 780)) ? 20 : 10;
      const addMoreTopSpace = (this.isDesktopWeb || isIpadLandscape) ? 45 : (screenWidth >= 576) ? 25 : 80;
      const width = (popover_view.offsetWidth != 0) ? popover_view.offsetWidth : (screenWidth <= 990 ) ? 230 : 290;
      const height = (popover_view.offsetHeight != 0) ? popover_view.offsetHeight : 163;
      popover.style.setProperty('--offset-x', -((screenWidth - width) / 2 - addMoreLeftSpace) + 'px', 'important');
      popover.style.setProperty('--offset-y', -((screenHeight - height) / 2 - addMoreTopSpace) + 'px', 'important');
    }, 30);
  }

  changePropertyInMobile(){
    const popover: any = document.querySelector('.auto-dismiss-popover');
    const isLandscape =  this.platform.isLandscape();
    const valueAdd = this.isIpad ? 0 : 50;
    const currentOffsetY = parseFloat(getComputedStyle(popover).getPropertyValue('--offset-y'));
    const newOffsetY = isLandscape ?  currentOffsetY - valueAdd : currentOffsetY + valueAdd;
    popover.style.setProperty('--offset-y', newOffsetY + 'px', 'important');
  }
}


export interface BonusContent {
  title?: string;
  amount?: number;
  isAutoHideEnabled?: boolean;
  isAutoHideTimeout?: number;
  istopLeft?: boolean;
  isFromLevel?:boolean;
  rewardedPoints?:string;
}
